<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-10" xl="10">
                        <div class="font-weight-bold body-1">
                            Nueva Proforma
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="10" xl="10">
                        <v-form ref="form" @submit.prevent="save">
                            <sale-bill-form :key="componentKey" ref="SaleBillForm" :values="form" @save="save" :serverErrors="serverErrors"></sale-bill-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="10" xl="10" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../helpers/Utils';
import SaleBillForm from "./Form.vue";


export default {
    components: {
        'sale-bill-form': SaleBillForm,
    },
	data(){
		return {
            componentKey: 0,
            loading: false,
            serverErrors: {},
            form: {
                receiver_id: "",
                payment_form: "",
                payment_method:"",
                cfdi_type: "",
                currency: "",
                date: "",
                comments: "",
                reference_id:"",
                cfdi_name_id: '',
                items: [
                    // {
                    //     "id_product": "dqxsMfaDwlz7dmlytnkhRA2",
                    //     "description": "Creacion de base de datos",
                    //     "tax_object":"02",
                    //     "unit_code": "E49",
                    //     "unit_price": 6500,
                    //     "quantity": 1,
                    //     "subtotal": 6500.00,
                    //     "discount": 0.0,
                    //     "taxes": [
                    //     {
                    //         "total": 1040,
                    //         "name": "IVA",
                    //         "base": 6500,
                    //         "rate": 0.16,
                    //         "is_retention": false
                    //     }
                    //     ],
                    //     "total": 7540.0
                    // }
                ]
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "SaleBills",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
	methods: {
		validate () {
            //console.log(this.serverErrors);
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
           
          
            // this.forceRerender();
			return this.$refs.form.validate();
            // return true;
		},
        forceRerender() {
            this.componentKey += 1;
        },
         onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        save(){
            
            console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                //console.log(form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.saleBill.store(this.$store.state.business,form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'SaleBills'});
                    })
                    .catch((error) => {
                        //console.log(error.response)
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                //console.log(99, error.response);
                                if(("error" in error.response.data)){
                                    console.log(error.response.data.error)
                                    if(typeof error.response.data.error === 'string'){
                                        this.$store.dispatch('snackbarError', error.response.data.error);
                                        return;
                                    }
                                    Object.keys(error.response.data.error).forEach((x) => {
                                        //console.log(x);
                                        this.serverErrors = error.response.data.error;
                                        error.response.data.error[x].forEach((y) => {
                                            this.serverErrors[x] = Utils.deleteWord(x,y);
                                            errors.push(Utils.deleteWord(x,y))
                                        })
                                    });
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }

                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));

            delete data.NameCodeProdServ;

            for (let i = 0; i < data.items.length; i++) {
                delete data.items[i].actions;
                delete data.items[i].isTaxItem;
                delete data.items[i].iva;
                delete data.items[i].parameters;
                delete data.items[i].unitText;
                
            }
            
            return data;
        }
    },
}
</script>

<style>

</style>